import * as React from 'react';

import { useLiveRef } from './useLiveRef';

/**
 * Create a stable API, a set of methods that are all memoized.
 * More performant alternative of `useEventCallback` + `useMemo`.
 */
export function useStableAPI<T extends Record<string, any>>(value: T): T {
    const ref = useLiveRef(value);
    const [api] = React.useState(() => {
        return Object.keys(value).reduce<any>((proxy, key) => {
            if (typeof value[key] === 'function') {
                proxy[key] = (...args: any[]) => ref.current[key](...args);
            }
            return proxy;
        }, {} as any);
    });
    return api;
}
